export const coachQueryKeys = {
	coachVerification: {
		all: ["coach-verification"] as const,
		queue: (status?: string, limit?: number, offset?: number) =>
			["coach-verification", "queue", status ?? "pending", limit, offset] as const,
	},
} as const;
